/* devices.icon.svg.js */

module.exports = {
    icon: `    
<svg viewBox="0 0 30.8 25"  preserveAspectRatio="none">
<style type="text/css">
	.st0{enable-background:new    ;}
	.st1{fill:#185771;}
	.st2{fill:#818181;}
	.st3{clip-path:url(#SVGID_1_);enable-background:new    ;}
	.st4{fill:#175A77;}
	.st5{fill:#165772;}
	.st6{clip-path:url(#SVGID_2_);enable-background:new    ;}
	.st7{clip-path:url(#SVGID_3_);enable-background:new    ;}
	.st8{fill:#858585;}
	.st9{fill:#828282;}
	.st10{clip-path:url(#SVGID_4_);enable-background:new    ;}
	.st11{clip-path:url(#SVGID_5_);enable-background:new    ;}
	.st12{clip-path:url(#SVGID_6_);enable-background:new    ;}
	.st13{clip-path:url(#SVGID_7_);enable-background:new    ;}
	.st14{clip-path:url(#SVGID_8_);enable-background:new    ;}
	.st15{clip-path:url(#SVGID_9_);enable-background:new    ;}
	.st16{fill:#2AA6DA;}
	.st17{fill:#F7F8F8;}
	.st18{fill:#175873;}
	.st19{clip-path:url(#SVGID_10_);enable-background:new    ;}
	.st20{clip-path:url(#SVGID_11_);enable-background:new    ;}
	.st21{clip-path:url(#SVGID_12_);enable-background:new    ;}
	.st22{clip-path:url(#SVGID_13_);enable-background:new    ;}
	.st23{clip-path:url(#SVGID_14_);enable-background:new    ;}
	.st24{clip-path:url(#SVGID_15_);enable-background:new    ;}
	.st25{opacity:0.36;fill:#1BAFE5;}
	.st26{opacity:0.46;fill:#FFFFFF;}
	.st27{fill:#4E4E4E;}
	.st28{fill:#A8AAAD;}
</style>
<g>
	<g id="XMLID_2_">
		<g class="st0">
			<g>
				<polygon class="st1" points="19.9,3.6 21.3,6.5 18.7,12 17.3,9.1 				"/>
			</g>
			<g>
				<polygon class="st2" points="18.8,8.5 20.2,11.4 18.7,12 17.3,9.1 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_31_" class="st0" d="M11.9,11.9l1.4,2.8c-0.5,0-0.9,0.4-0.9,0.9L11,12.8C11,12.3,11.4,11.9,11.9,11.9z"/>
				</defs>
				<clipPath id="SVGID_1_">
					<use xlink:href="#SVGID_31_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st3">
					<path class="st4" d="M11.9,11.9l1.4,2.8c-0.5,0-0.9,0.4-0.9,0.9L11,12.8C11,12.3,11.4,11.9,11.9,11.9"/>
				</g>
			</g>
			<g>
				<polygon class="st5" points="11,12.8 12.3,15.6 11.2,15.6 9.8,12.8 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_33_" class="st0" d="M12.3,15.6c0,0.1,0,0.3,0.1,0.4L11,13.2C11,13,10.9,12.9,11,12.8
						C11.4,13.6,12.2,14.7,12.3,15.6z"/>
				</defs>
				<clipPath id="SVGID_2_">
					<use xlink:href="#SVGID_33_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st6">
					<path class="st4" d="M11,12.8l1.4,2.8c0,0.1,0,0.3,0.1,0.4L11,13.2C11,13,10.9,12.9,11,12.8"/>
				</g>
			</g>
			<g>
				<polygon class="st1" points="13.6,10.4 15,13.3 15.6,14.7 14.2,11.8 				"/>
			</g>
			<g>
				<polygon class="st5" points="14.2,11.8 15.6,14.7 13.3,14.7 11.9,11.9 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_35_" class="st0" d="M12.4,16L11,13.2c0.1,0.3,0.4,0.5,0.8,0.5l1.4,2.8C12.9,16.5,12.6,16.3,12.4,16z"/>
				</defs>
				<clipPath id="SVGID_3_">
					<use xlink:href="#SVGID_35_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st7">
					<path class="st8" d="M11.8,13.6l1.4,2.8c-0.4,0-0.7-0.2-0.8-0.5L11,13.2C11.2,13.4,11.5,13.6,11.8,13.6"/>
				</g>
			</g>
			<g>
				<polygon class="st1" points="18.8,8.5 20.2,11.4 20.2,13.5 18.8,10.7 				"/>
			</g>
			<g>
				<polygon class="st9" points="22.1,9.1 23.5,11.9 22.1,11.3 20.7,8.5 				"/>
			</g>
			<g>
				<polygon class="st2" points="19.9,3.6 21.3,6.5 23.5,11.9 22.1,9.1 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_37_" class="st0" d="M20.2,13.9l-1.4-2.8c-0.1-0.1-0.1-0.3-0.1-0.4l1.4,2.8C20.1,13.7,20.2,13.8,20.2,13.9z"/>
				</defs>
				<clipPath id="SVGID_4_">
					<use xlink:href="#SVGID_37_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st10">
					<path class="st4" d="M18.8,10.7l1.4,2.8c0,0.1,0,0.3,0.1,0.4l-1.4-2.8C18.8,11,18.8,10.8,18.8,10.7"/>
				</g>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_39_" class="st0" d="M20.3,14C20.3,14,20.2,14,20.3,14l-1.4-2.9c0,0,0,0,0,0.1c0,0.1,0.1,0.2,0.2,0.3
						c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4
						c0.1,0.1,0.1,0.2,0.2,0.4C20.2,13.8,20.2,13.9,20.3,14z"/>
				</defs>
				<clipPath id="SVGID_5_">
					<use xlink:href="#SVGID_39_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st11">
					<path class="st8" d="M20.6,10.7l1.4,2.8c0,0.5-0.4,0.9-0.9,0.9c-0.4,0-0.7-0.2-0.8-0.5l-1.4-2.8c0.1,0.3,0.4,0.5,0.8,0.5
						C20.1,11.6,20.6,11.2,20.6,10.7"/>
				</g>
			</g>
			<g>
				<polygon class="st2" points="14.1,13.6 15.5,16.5 13.2,16.5 11.8,13.6 				"/>
			</g>
			<g>
				<polygon class="st2" points="20.7,8.5 22.1,11.3 22,13.5 20.6,10.7 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_41_" class="st0" d="M22,13.5c0,0.2,0,0.3-0.1,0.4c-0.5-0.9-0.9-1.9-1.4-2.8c0.1-0.1,0.1-0.3,0.1-0.4
						C21,11.5,21.8,12.6,22,13.5z"/>
				</defs>
				<clipPath id="SVGID_6_">
					<use xlink:href="#SVGID_41_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st12">
					<path class="st8" d="M20.6,10.7l1.4,2.8c0,0.5-0.4,0.9-0.9,0.9c-0.4,0-0.7-0.2-0.8-0.5l-1.4-2.8c0.1,0.3,0.4,0.5,0.8,0.5
						C20.1,11.6,20.6,11.2,20.6,10.7"/>
				</g>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_43_" class="st0" d="M21,14.4c-0.3,0-0.6-0.2-0.8-0.4c-0.5-0.9-0.9-1.9-1.4-2.8c0.2,0.2,0.4,0.4,0.8,0.4
						c0.4,0,0.7-0.2,0.8-0.5c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4
						c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.2,0.2,0.4c0,0.1,0.1,0.2,0.2,0.3C21.7,14.2,21.4,14.4,21,14.4
						z"/>
				</defs>
				<clipPath id="SVGID_7_">
					<use xlink:href="#SVGID_43_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st13">
					<path class="st8" d="M20.6,10.7l1.4,2.8c0,0.5-0.4,0.9-0.9,0.9c-0.4,0-0.7-0.2-0.8-0.5l-1.4-2.8c0.1,0.3,0.4,0.5,0.8,0.5
						C20.1,11.6,20.6,11.2,20.6,10.7"/>
				</g>
			</g>
			<g>
				<polygon class="st1" points="25.8,10.3 27.2,13.2 21.4,15.5 20,12.7 				"/>
			</g>
			<g>
				<polygon class="st2" points="25.8,10.3 27.2,13.2 26.5,14.6 25.1,11.8 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_45_" class="st0" d="M28.2,12.2l1.4,2.8c-0.1-0.3-0.4-0.5-0.8-0.5l-1.4-2.8C27.7,11.7,28,11.9,28.2,12.2z"/>
				</defs>
				<clipPath id="SVGID_8_">
					<use xlink:href="#SVGID_45_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st14">
					<path class="st4" d="M28.2,12.2l1.4,2.8c-0.1-0.3-0.4-0.5-0.8-0.5l-1.4-2.8C27.7,11.7,28,11.9,28.2,12.2"/>
				</g>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_47_" class="st0" d="M28.5,8.3l1.4,2.8c0.6,1.3,1,2.7,0.9,4.3l-1.4-2.8C29.5,11.1,29.1,9.6,28.5,8.3z"/>
				</defs>
				<clipPath id="SVGID_9_">
					<use xlink:href="#SVGID_47_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st15">
					<path class="st4" d="M28.5,8.3l1.4,2.8c0.6,1.3,1,2.7,0.9,4.3l-1.4-2.8C29.5,11.1,29.1,9.6,28.5,8.3"/>
				</g>
			</g>
			<g>
				<path class="st16" d="M20,3.2c5.4,0,9.6,4.2,9.4,9.4l-1.2,0c0-0.5-0.4-0.9-0.9-0.9l-2.3,0l0.7-1.4L20,12.7l-0.9,0l-5.6-2.3
					l0.6,1.4l-2.3,0c-0.5,0-0.9,0.4-0.9,0.9l-1.2,0C10,7.5,14.6,3.3,20,3.2z M20.7,8.5l1.5,0.6l-2.2-5.5l-2.6,5.5l1.5-0.6l-0.1,2.2
					c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9L20.7,8.5"/>
			</g>
			<g>
				<path class="st17" d="M19.9,3.6l2.2,5.5l-1.5-0.6l-0.1,2.2c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9l0.1-2.2l-1.5,0.6
					L19.9,3.6z"/>
			</g>
			<g>
				<polygon class="st1" points="14.1,13.6 15.5,16.5 14.8,17.9 13.4,15.1 				"/>
			</g>
			<g>
				<polygon class="st18" points="19.2,12.7 20.6,15.5 15,13.3 13.6,10.4 				"/>
			</g>
			<g>
				<polygon class="st2" points="19.2,12.7 20.6,15.5 14.8,17.9 13.4,15.1 				"/>
			</g>
			<g>
				<path class="st17" d="M13.6,10.4l5.6,2.3l-5.8,2.4l0.7-1.4l-2.3,0c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9l2.3,0
					L13.6,10.4z"/>
			</g>
			<g>
				<polygon class="st5" points="20,12.7 21.4,15.5 20.6,15.5 19.2,12.7 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_49_" class="st0" d="M20.3,14.3l1.4,2.8c-0.1-0.3-0.4-0.5-0.8-0.5c-0.5,0-0.9,0.4-0.9,0.9l-1.4-2.8
						c0-0.5,0.4-0.9,0.9-0.9C19.9,13.8,20.2,14,20.3,14.3z"/>
				</defs>
				<clipPath id="SVGID_10_">
					<use xlink:href="#SVGID_49_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st19">
					<path class="st4" d="M20.3,14.3l1.4,2.8c-0.1-0.3-0.4-0.5-0.8-0.5c-0.5,0-0.9,0.4-0.9,0.9l-1.4-2.8c0-0.5,0.4-0.9,0.9-0.9
						C19.9,13.8,20.2,14,20.3,14.3"/>
				</g>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_51_" class="st0" d="M21.8,17.3c-0.5-0.9-0.9-1.9-1.4-2.8c0-0.1,0-0.2-0.1-0.2l1.4,2.8
						C21.8,17.2,21.8,17.3,21.8,17.3z"/>
				</defs>
				<clipPath id="SVGID_11_">
					<use xlink:href="#SVGID_51_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st20">
					<path class="st8" d="M20.3,14.3l1.4,2.8c0.1,0.1,0.1,0.3,0.1,0.4l-1.4-2.8C20.4,14.5,20.4,14.4,20.3,14.3"/>
				</g>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_53_" class="st0" d="M21.8,17.3c0,0.1,0,0.1,0,0.2l-1.4-2.8c0-0.1,0-0.1,0-0.2c0,0.1,0.1,0.2,0.1,0.3
						c0,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.2,0.3
						c0,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C21.8,17.2,21.8,17.3,21.8,17.3
						z"/>
				</defs>
				<clipPath id="SVGID_12_">
					<use xlink:href="#SVGID_53_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st21">
					<path class="st8" d="M20.3,14.3l1.4,2.8c0.1,0.1,0.1,0.3,0.1,0.4l-1.4-2.8C20.4,14.5,20.4,14.4,20.3,14.3"/>
				</g>
			</g>
			<g>
				<polygon class="st5" points="27.4,11.7 28.8,14.6 26.5,14.6 25.1,11.8 				"/>
			</g>
			<g>
				<polygon class="st5" points="18.5,16.9 19.9,19.7 18.5,19.1 17.1,16.3 				"/>
			</g>
			<g>
				<polygon class="st1" points="18.6,14.7 20,17.5 19.9,19.7 18.5,16.9 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_55_" class="st0" d="M29.5,15.1c0.1,0.1,0.1,0.3,0.1,0.4c-0.5-0.9-0.9-1.9-1.4-2.8c0-0.1,0-0.3-0.1-0.4
						C28.6,13.1,29.1,14.2,29.5,15.1z"/>
				</defs>
				<clipPath id="SVGID_13_">
					<use xlink:href="#SVGID_55_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st22">
					<path class="st8" d="M28.2,12.2l1.4,2.8c0.1,0.1,0.1,0.3,0.1,0.4c0,0.5-0.4,0.9-0.9,0.9l-1.4-2.8c0.5,0,0.9-0.4,0.9-0.9
						C28.2,12.5,28.2,12.3,28.2,12.2"/>
				</g>
			</g>
			<g>
				<polygon class="st2" points="20.4,14.7 21.8,17.5 21.7,19.7 20.3,16.9 				"/>
			</g>
			<g>
				<polygon class="st2" points="27.3,13.5 28.7,16.4 26.4,16.4 25,13.5 				"/>
			</g>
			<g>
				<polygon class="st1" points="21.9,16.2 23.3,19.1 21.7,19.7 20.3,16.9 				"/>
			</g>
			<g>
				<polygon class="st5" points="29.4,12.6 30.8,15.5 29.6,15.5 28.2,12.6 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_57_" class="st0" d="M29.6,15.5c0,0.5-0.4,0.9-0.9,0.9l-1.4-2.8c0.5,0,0.9-0.4,0.9-0.9l0,0
						c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4
						c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.2,0.2,0.4C29.5,15.2,29.6,15.4,29.6,15.5L29.6,15.5z"/>
				</defs>
				<clipPath id="SVGID_14_">
					<use xlink:href="#SVGID_57_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st23">
					<path class="st8" d="M28.2,12.2l1.4,2.8c0.1,0.1,0.1,0.3,0.1,0.4c0,0.5-0.4,0.9-0.9,0.9l-1.4-2.8c0.5,0,0.9-0.4,0.9-0.9
						C28.2,12.5,28.2,12.3,28.2,12.2"/>
				</g>
			</g>
			<g>
				<polygon class="st9" points="25.6,15 27,17.8 21.4,15.5 20,12.7 				"/>
			</g>
			<g>
				<polygon class="st2" points="25,13.5 26.4,16.4 27,17.8 25.6,15 				"/>
			</g>
			<g>
				<path class="st17" d="M25.8,10.3l-0.7,1.4l2.3,0c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9l-2.3,0l0.6,1.4L20,12.7L25.8,10.3z"/>
			</g>
			<g>
				<polygon class="st1" points="17.1,16.3 18.5,19.1 20.6,24.6 19.2,21.7 				"/>
			</g>
			<g>
				<path class="st17" d="M19.6,13.8c0.5,0,0.9,0.4,0.9,0.9l-0.1,2.2l1.5-0.6l-2.6,5.5l-2.2-5.5l1.5,0.6l0.1-2.2
					C18.6,14.2,19,13.8,19.6,13.8z"/>
			</g>
			<g>
				<polygon class="st2" points="21.9,16.2 23.3,19.1 20.6,24.6 19.2,21.7 				"/>
			</g>
			<g class="st0">
				<defs>
					<path id="SVGID_59_" class="st0" d="M12.1,19.9l-1.4-2.8c1.5,3.1,4.7,5.1,8.5,5.1c5.4,0,10-4.3,10.2-9.5l1.4,2.8
						C30.6,20.7,26,25,20.6,25C16.8,25,13.6,23,12.1,19.9z"/>
				</defs>
				<clipPath id="SVGID_15_">
					<use xlink:href="#SVGID_59_"  style="overflow:visible;"/>
				</clipPath>
				<g class="st24">
					<path class="st4" d="M29.4,12.6l1.4,2.8C30.6,20.7,26,25,20.6,25c-3.8,0-7-2-8.5-5.1l-1.4-2.8c1.5,3.1,4.7,5.1,8.5,5.1
						C24.6,22.1,29.2,17.8,29.4,12.6"/>
				</g>
			</g>
			<g>
				<path class="st16" d="M28.2,12.6l1.2,0c-0.2,5.2-4.8,9.5-10.2,9.5c-5.4,0-9.6-4.2-9.4-9.4l1.2,0c0,0.5,0.4,0.9,0.9,0.9l2.3,0
					l-0.7,1.4l5.8-2.4l0.9,0l5.6,2.3L25,13.5l2.3,0C27.8,13.5,28.2,13.1,28.2,12.6z M19.2,21.7l2.6-5.5l-1.5,0.6l0.1-2.2
					c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9l-0.1,2.2l-1.5-0.6L19.2,21.7"/>
			</g>
		</g>
	</g>
	<g>
		<ellipse transform="matrix(0.9413 -0.3375 0.3375 0.9413 -1.4343 3.7081)" class="st25" cx="9.9" cy="6" rx="5.4" ry="5.4"/>
		<path class="st26" d="M10.8,8.5c-0.3,0.1-0.7-0.1-0.8-0.4c-0.1-0.3,0.1-0.7,0.4-0.8c1.2-0.4,1.9-1.8,1.4-3
			c-0.1-0.3,0.1-0.7,0.4-0.8S12.8,3.7,13,4C13.6,5.8,12.6,7.9,10.8,8.5z"/>
		<path class="st27" d="M14.8,9.4c1.7-2.6,1-6.2-1.6-7.9c-2.6-1.7-6.2-1-7.9,1.6c-1.6,2.5-1.1,5.7,1.1,7.6l-1.7,2.5l-0.4-0.3
			l-4.1,6.2L2,20.3l4.1-6.2l-0.5-0.3l1.7-2.5C9.9,12.7,13.2,11.9,14.8,9.4z M6.3,3.8c1.4-2.1,4.1-2.6,6.2-1.2
			c2.1,1.4,2.6,4.1,1.2,6.2c-1.4,2.1-4.1,2.6-6.2,1.2C5.5,8.6,5,5.9,6.3,3.8z"/>
		<path class="st28" d="M14.6,8.9c1.7-2.6,1-6.2-1.6-7.9c-2.6-1.7-6.2-1-7.9,1.6C3.5,5,4,8.3,6.2,10.1l-1.7,2.5l-0.4-0.3L0,18.5
			l1.8,1.2l4.1-6.2l-0.5-0.3l1.7-2.5C9.7,12.1,13,11.4,14.6,8.9z M6.1,3.2c1.4-2.1,4.1-2.6,6.2-1.2c2.1,1.4,2.6,4.1,1.2,6.2
			c-1.4,2.1-4.1,2.6-6.2,1.2C5.3,8.1,4.8,5.3,6.1,3.2z"/>
	</g>
</g>
</svg>`
};
